<template>
  <div class="container">
    <div class="container__row">
      <div class="container__row--content">
        <slot name="content"></slot>
      </div>
      <div class="container__row--action">
        <button-text class="btn btn--primary" :action="onSubmit" data-action="start" data-category="app_onboard_flow">
          <template #body>
            <div>ตกลง</div>
          </template>
        </button-text>
      </div>
    </div>
  </div>
</template>

<script>
import { ButtonText } from "../../atoms"
export default {
  components: {
    ButtonText
  },
  data() {
    return {}
  },
  methods: {
    onSubmit() {
      this.$emit("callback-submit", { val: true })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/_DialogBanner";
</style>